import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TransferLeadComponent } from './transfer-lead.component';

const routes: Routes = [{ path: '', component: TransferLeadComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TransferLeadRoutingModule { }
